export default __webpack_public_path__ + "static/feature-cohorts-dfa2f2c6a7cd3f4cb7dc0084d4599a1c.png";